import { AIIcon } from '@cobliteam/ai';
import Tag, { type TagProps } from '@cobliteam/ui/components/Tag';
import Tooltip from '@cobliteam/ui/components/Tooltip';
import { cn } from '@cobliteam/ui/utils';
import { ShineTag } from '../ShineTag/ShineTag';

const ShineNew = (props: TagProps) => {
  return <ShineTag label={props.label || 'Novo'} {...props} />;
};

const New = (props: TagProps) => {
  return <Tag label={props.label || 'Novo'} {...props} color='success' />;
};

const AI = ({ className, style, ...props }: TagProps) => {
  return (
    <Tag
      label={props.label || 'AI'}
      {...props}
      icon={<AIIcon size={22} animationActive={false} sparklesPaint='brand-gradient' />}
      color='default'
      variant='default'
      style={style}
      className={cn(
        'border border-accessory-purple-6 bg-[linear-gradient(90deg,rgba(255,255,255,0.85)_0%,rgba(255,255,255,0.85)_100%),linear-gradient(90deg,#0745cf_0%,#9847ee_100%)] font-bold text-accessory-purple-11 shadow-none [&>div]:gap-0!',
        className
      )}
    />
  );
};

const Beta = (props: TagProps) => {
  return (
    <Tooltip content='Beta é um recurso que está em fase de teste e está disponível para todos ou quase todos os usuários.' asChild>
      <div className='w-fit cursor-help'>
        <Tag label={props.label || 'Beta'} {...props} color='primary' />
      </div>
    </Tooltip>
  );
};

const BetaPrivate = (props: TagProps) => {
  return (
    <Tooltip content='Beta Privado é um recurso que está em fase de teste e não está disponível para todos os usuários.' asChild>
      <div className='w-fit cursor-help'>
        <Tag label={props.label || '🔒 Beta Privado'} {...props} color='primary' />
      </div>
    </Tooltip>
  );
};

const BetaLimited = (props: TagProps) => {
  return (
    <Tooltip content='Beta Limitado é um recurso que está em fase de teste e está disponível para um número limitado de usuários.' asChild>
      <div className='w-fit cursor-help'>
        <Tag label={props.label || '🔐 Beta Limitado'} {...props} color='primary' />
      </div>
    </Tooltip>
  );
};

const Alpha = (props: TagProps) => {
  return (
    <Tooltip content='Alfa é um recurso que está em fase de desenvolvimento e está disponível para muito poucos usuários.' asChild>
      <div className='w-fit cursor-help'>
        <Tag label={props.label || 'Alfa'} {...props} color='purple' />
      </div>
    </Tooltip>
  );
};

export default {
  New,
  AI,
  Beta,
  BetaPrivate,
  BetaLimited,
  Alpha,
  ShineNew,
};
